import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/ui/PageHeader';
import { TeacherSessions } from '@/features/sessions/TeacherSessions';

export const Route = createFileRoute('/admin/sessions')({
  component: AdminSessionsPage,
});

function AdminSessionsPage() {
  return (
    <div className="grid gap-6">
      <PageHeader
        eyebrow="Staff portal"
        title="Speaking sessions"
        description="Offer times, share the meeting link and close sessions with bands."
      />
      <TeacherSessions />
    </div>
  );
}
